module.exports = __webpack_public_path__ + "img/IMG_9621_L_WoodMatted_MockedUp.6b60eb8d.jpg";